"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var Bassinet = function Bassinet(props) {
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M11.9998 5.99984H7.99984V2.6665H5.33317C3.85984 2.6665 2.6665 3.85984 2.6665 5.33317V9.33317C2.6665 10.0665 3.2665 10.6665 3.99984 10.6665H5.33317V12.6198C4.9265 12.3865 4.55984 12.0998 4.23317 11.7732L3.2865 12.7198C4.49317 13.9198 6.15984 14.6665 7.99984 14.6665C9.83984 14.6665 11.5065 13.9198 12.7132 12.7132L11.7665 11.7665C11.4398 12.0932 11.0665 12.3798 10.6665 12.6132V10.6665H11.9998C12.7332 10.6665 13.3332 10.0665 13.3332 9.33317V7.33317C13.3332 6.59984 12.7332 5.99984 11.9998 5.99984ZM9.33317 13.1665C8.9065 13.2732 8.45984 13.3332 7.99984 13.3332C7.53984 13.3332 7.09317 13.2732 6.6665 13.1665V10.6665H9.33317V13.1665Z",
    fill: "#75767A"
  }, colorStyles)));
};
Bassinet.propTypes = _inline_svg2.default.propTypes;
Bassinet.defaultProps = _inline_svg2.default.defaultProps;
var _default = Bassinet;
exports.default = _default;